import { photo, PhotoVariantProps } from "./photo.variants";

export type UsePhotoProps = ComponentProps<
  {
    image: string;
    alt: string;
    title?: string;
    description?: string;
    position?: string;
  },
  PhotoVariantProps & {
    handleClick?: () => void;
  }
>;

export const usePhoto = (props: UsePhotoProps) => {
  const {
    className = "",
    type = "photo",
    handleClick = () => {},
    data,
  } = props;

  const styles = photo({ type });

  return {
    styles,
    className,
    handleClick,
    type,
    data,
  };
};
